import * as React from 'react';

import { cn } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import * as conversationState from '../../_state/chatConversation.state';
import * as chatListState from '../../_state/chatList.state';

import { ChatConversation } from './ChatConversation';
import { ChatList } from './ChatList';

interface ChatSidebarViewProps {
  className?: string;
}

//
// ⚛️ ⚛️ ⚛️ CHAT SIDEBAR VIEW ⚛️ ⚛️ ⚛️
//
export const ChatSidebarView = ({ className }: ChatSidebarViewProps = {}) => {
  // States
  const [isListOpen, setIsListOpen] = React.useState(false);

  // Atoms
  const selectedChatId = useAtomValue(conversationState.$selectedChatId);
  const chatData = useAtomValue(chatListState.$chatsWithOptimisticTitles);
  const autoSelectOrCreateChat = useSetAtom(
    chatListState.$autoSelectOrCreateChat,
  );

  /** Auto-selects or creates a chat when none is selected */
  React.useEffect(() => {
    if (!selectedChatId && chatData.data) {
      autoSelectOrCreateChat();
    }
  }, [selectedChatId, chatData.data, autoSelectOrCreateChat]);

  return (
    <div
      className={cn(
        '@ChatSidebarView',
        'relative h-full w-full overflow-hidden bg-white',
        className,
      )}
    >
      <div className="flex h-full flex-col">
        <ChatConversation onOpenList={() => setIsListOpen(true)} />
      </div>

      <div
        className={cn(
          'absolute inset-y-2 left-2 z-10 w-60 overflow-hidden rounded-xl shadow-lg transition-transform duration-300 ease-in-out',
          isListOpen && 'translate-x-0',
          !isListOpen && 'translate-x-[calc(-110%)]',
        )}
      >
        <ChatList onClose={() => setIsListOpen(false)} />
      </div>
    </div>
  );
};
